export default {
    FUSO_HORARIO_DEFAULT: 'America/Campo_Grande',
}
